/**
 * Recommended value for `PROPAGATED_HEADERS` in Signadot-capable environments:
 * the headers Signadot uses to route requests to sandboxed downstream services,
 * so a sandbox route survives the hop through sb-shell. Exported for reference
 * and to keep the env files in sync. Additional headers (e.g. W3C / Datadog
 * trace-context headers) can be appended per-environment without a code change.
 */
export const DEFAULT_PROPAGATED_HEADERS: readonly string[] = ['baggage', 'tracestate'];

/**
 * Resolves which header names to propagate, from the `PROPAGATED_HEADERS` env
 * var (comma-separated). Propagation is **opt-in**: unset or empty → `[]`, so it
 * is off by default everywhere — production never enables it unless explicitly
 * configured, which (with the dedicated-instance design) keeps it well clear of
 * the Apr 8 2026 incident. The non-prod env files opt in with
 * {@link DEFAULT_PROPAGATED_HEADERS}.
 *
 * HTTP header names are case-insensitive; names are lowercased so `Headers.get`
 * and the outbound `set` behave consistently.
 */
export function getPropagatedHeaderNames(): readonly string[] {
    return (process.env.PROPAGATED_HEADERS ?? '')
        .split(',')
        .map((name) => name.trim().toLowerCase())
        .filter(Boolean);
}
